import React from 'react'

import { Box, Text, Link } from '@vividseats/vivid-ui-kit'

import { IMAGES } from '@/constants'

import { BUTTON_LABELS, GET_THE_APP_URL_STRING } from '../constants'
import styles from '../styles.module.scss'

const FreeToJoin: React.FC = () => (
    <Box
        desktopMarginTop={7}
        marginBottom={8}
        display="flex"
        align="center"
        justify="center"
        desktopFlexDirection="row"
        tabletFlexDirection="column"
        mobileFlexDirection="column"
    >
        <Box className={styles.center}>
            <img
                srcSet={`${IMAGES.REWARDS_FREE_TO_JOIN_MOBILE} 480w, ${IMAGES.REWARDS_FREE_TO_JOIN_DESKTOP} 800w`}
                sizes="(max-width: 600px) 300px, 400px"
                src={IMAGES.REWARDS_FREE_TO_JOIN_DESKTOP}
                alt="free to join"
                loading="lazy"
            />
        </Box>
        <Box
            display="flex"
            tabletFlexDirection="column"
            mobileFlexDirection="column"
            desktopPaddingTop={18}
            desktopPaddingLeft={10}
            mobilePaddingTop={6}
            className={styles.textBlock}
        >
            <Text as="h2" className={styles.title}>
                Free to join
            </Text>
            <Box desktopPaddingTop={4} tabletPaddingTop={4} mobilePaddingTop={1} marginBottom={6}>
                <Text>
                    Opt in to Vivid Seats Rewards in the app. Then, start earning by going to the events you love!
                </Text>
            </Box>
            <Box paddingBottom={8}>
                <Link className={styles.button} href={GET_THE_APP_URL_STRING} isExternal>
                    {BUTTON_LABELS.getApp}
                </Link>
            </Box>
        </Box>
    </Box>
)

export default FreeToJoin
